const prefix = 'logo';

export const i18n = {
    logoAlt: {
        id: `${prefix}.logoAlt`,
        defaultMessage: 'Imago',
    },
} as const;
